/**
 * Converte string MySQL (YYYY-MM-DD HH:mm:ss) para Date local,
 * sem interpretar como UTC (evita shift de fuso horário).
 * Ex: "2026-02-14 20:27:00" → Date local 20:27 (America/Sao_Paulo).
 */
export function parseMySQLDateLocal(str: string): Date {
  if (!str || typeof str !== "string") return new Date(str);
  const match = str.match(/^(\d{4})-(\d{2})-(\d{2})[\sT](\d{2}):(\d{2}):(\d{2})/);
  if (!match) return new Date(str);
  const [, y, m, d, h, min, s] = match;
  return new Date(
    Number(y),
    Number(m) - 1,
    Number(d),
    Number(h),
    Number(min),
    Number(s)
  );
}

export function formatarDataLocal(date: Date): string {
  return date.toLocaleDateString("pt-BR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
}

export function formatarHoraLocal(date: Date): string {
  return date.toLocaleTimeString("pt-BR", {
    hour: "2-digit",
    minute: "2-digit",
  });
}

/** Alias para parseMySQLDateLocal (datetime como local, evita UTC). */
export function parseDateTimeLocal(str: string): Date {
  return parseMySQLDateLocal(str);
}

const TZ_SP = "America/Sao_Paulo";

/** Retorna data de hoje em America/Sao_Paulo no formato YYYY-MM-DD. */
export function getTodaySaoPaulo(): string {
  return new Date().toLocaleDateString("en-CA", { timeZone: TZ_SP });
}

/** Soma delta dias a uma data ISO (YYYY-MM-DD) e retorna YYYY-MM-DD. */
export function addDaysIso(isoDate: string, delta: number): string {
  const d = new Date(isoDate + "T12:00:00Z");
  d.setUTCDate(d.getUTCDate() + delta);
  return d.toISOString().slice(0, 10);
}

/** Parse apenas data YYYY-MM-DD como meio-dia local (evita drift de fuso). */
export function parseIsoDateOnlyLocal(iso: string): Date {
  const m = iso.trim().match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!m) return new Date(iso);
  return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]), 12, 0, 0, 0);
}

/**
 * Dias até o vencimento em relação a hoje (America/Sao_Paulo).
 * Positivo = dias restantes; zero = vence hoje; negativo = atrasado (ex.: -2).
 */
export function diffCalendarDaysVencimentoHojeSP(dataVencimento: string): number {
  const v = parseIsoDateOnlyLocal(dataVencimento);
  const t = parseIsoDateOnlyLocal(getTodaySaoPaulo());
  const msPerDay = 24 * 60 * 60 * 1000;
  return Math.round((v.getTime() - t.getTime()) / msPerDay);
}
